import { createStore } from 'vuex'

// Create a new store instance.
const store = createStore({
    state: {
        adminLoggedIn: false,
        adminList: localStorage.getItem("Admin") ? JSON.parse(localStorage.getItem("Admin")) : [],
        items: localStorage.getItem("Employee") ? JSON.parse(localStorage.getItem("Employee")) : [],
    },
    getters: {

    },
    mutations: {
        SIGN_IN_ADMIN(state, adminSignIn){
            const found = state.adminList.some(el => {
                return el.email === adminSignIn.email && el.password === adminSignIn.password
            });
            if(found){
                state.adminLoggedIn = true
            }
        },
        NEW_ADMIN(state, adminData){
            state.adminList.push({
                id: Date.now().toString(),
                firstName: adminData.firstname,
                lastName: adminData.lastname,
                email: adminData.email,
                phone: adminData.phoneNumber,
                password: adminData.password,
                random: Math.floor(Math.random() * (3 - 1 + 1) ) + 1
            })
            localStorage.setItem("Admin", JSON.stringify(state.adminList))
        },
        NEW_USER(state, userData){
            state.items.push({
                id : Date.now().toString(),
                firstName: userData.firstname,
                lastName: userData.lastname,
                email: userData.email,
                phone: userData.phoneNumber,
                random: Math.floor(Math.random() * (3 - 1 + 1) ) + 1
            })
            localStorage.setItem("Employee", JSON.stringify(state.items))
        },
        DELETE_USER(state, itemId){
            let newItems = state.items.filter(v => v.id !== itemId)
            state.items = newItems
            localStorage.setItem("Employee", JSON.stringify(newItems))
        },
        EDIT_USER(state, userData){
            state.items.forEach((el, index) => {
                if(el.id === userData.id){
                    state.items[index].id = userData.id
                    state.items[index].firstName = userData.firstname
                    state.items[index].lastName = userData.lastname
                    state.items[index].email = userData.email
                    state.items[index].phone = userData.phoneNumber
                }
            });
            localStorage.setItem("Employee", JSON.stringify(state.items))
        }
    },
    actions: {
        signInAdmin({commit}, adminSignIn){
            commit("SIGN_IN_ADMIN", adminSignIn)
        },
        addNewAdmin({commit}, adminData){
            commit("NEW_ADMIN", adminData)
        },
        addNewUser({commit}, userData){
            commit("NEW_USER", userData)
        },
        deleteUser({commit}, item){
            commit("DELETE_USER", item.id)
        },
        editUser({commit}, userData){
            console.log(userData)
            commit("EDIT_USER", userData)
        }
    }
})
export default store